<template>
  <!-- Toolbar -->
  <v-app-bar id="upp-bar" color="white" flat>
    <div class="d-flex align-center">
      <v-icon color="primary" class="mr-2" size="large">
        mdi-ruler-square-compass
      </v-icon>
      <a
        class="text-primary text-h5 text-decoration-none font-weight-light"
        href="/rules"
      >
        {{ $t("labels.page-title") }}
      </a>
      <v-icon>mdi-chevron-right</v-icon>
      <v-tooltip location="bottom" color="primary">
        <template v-slot:activator="{ props }">
          <div
            id="rule_title"
            class="text-primary text-h5 font-weight-bold text-truncate"
            v-bind="props"
          >
            {{ rule.name }}
          </div>
        </template>
        <span>{{ rule.name }}</span>
      </v-tooltip>
    </div>
    <v-spacer></v-spacer>
    &emsp;
    <v-spacer></v-spacer>
    <v-menu location="bottom left">
      <template v-slot:activator="{ props }">
        <v-btn v-bind="props" color="primary">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item>
          <v-list-item @click="renameRule(item)">
            <template v-slot:prepend>
              <v-icon class="opacity-100" color="primary"
                >mdi-form-textbox</v-icon
              >
            </template>
            <v-list-item-title>{{ $t("labels.rename") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="deleteRule()" :disabled="!ruleId">
            <template v-slot:prepend>
              <v-icon class="opacity-100" color="primary">mdi-delete</v-icon>
            </template>
            <v-list-item-title>{{ $t("labels.delete") }}</v-list-item-title>
          </v-list-item>
        </v-list-item>
      </v-list>
    </v-menu>
    <!--Dialog Delete-->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-toolbar flat color="secondary">
          <v-toolbar-title class="text-white">
            {{ $t("labels.delete") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" @click="closeDeleteRule">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p class="text-h6 mt-4">
            {{ $t("strings.delete-rule-question", numDelete) }}
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            variant="text"
            @click="closeDeleteRule"
          >
            {{ $t("labels.cancel") }}
          </v-btn>
          <v-btn
            color="secondary darken-1"
            variant="text"
            @click="deleteRuleConfirm"
            :loading="loading"
            :disabled="loading"
          >
            {{ $t("labels.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Dialog Rename-->
    <DialogRename
      :dialogRename="dialogRename"
      :nameToEdit="ruleName"
      @closeDialog="closeRenameRule"
      @renameRule="renameRuleConfirm"
    ></DialogRename>
  </v-app-bar>
</template>

<script>
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import axios from "axios";
import DialogRename from "@/components/DialogRename.vue";

export default {
  mixins: [utils, events],
  props: ["rule", "realm", "apiUrl"],
  components: {
    DialogRename,
  },
  data: function () {
    return {
      loading: false,
      editedItem: null,
      dialogDelete: false,
      dialogRename: false,
    };
  },
  computed: {
    ruleId() {
      return this.rule.id;
    },
    ruleName() {
      return this.rule.name;
    },
  },
  methods: {
    // DELETE RULE
    async deleteRule() {
      this.editedItem = Object.assign({}, this.rule);
      this.dialogDelete = true;
    },
    async deleteRuleConfirm() {
      this.loading = true;
      try {
        await axios.delete(
          this.apiUrl + "/" + this.realm + "/rules/" + this.editedItem?.id,
          this.opts,
        );
        // Emit the snackbar event
        this.$emit("snackbarEvent", true, this.$t("strings.rule-deleted"));
        // Wait for a short delay (e.g., 1 second) to allow the snackbar to display
        await new Promise((resolve) => setTimeout(resolve, 1500));
        // Redirect to Home
        this.$router.push("/rules");
      } catch (error) {
        this.setError(error, false);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    closeDeleteRule() {
      this.dialogDelete = false;
    },

    //RENAME RULE
    renameRule() {
      this.dialogRename = true;
    },
    closeRenameRule() {
      this.dialogRename = false;
    },
    async renameRuleConfirm(name) {
      this.loader = true;
      try {
        await axios.patch(
          this.apiUrl + "/" + this.realm + "/rules/" + this.rule.id,
          { title: name },
          this.opts,
        );
        // Emit the snackbar event
        this.$emit(
          "snackbarEvent",
          true,
          this.$t("strings.rename-rule-success"),
        );
        // Wait for a short delay (e.g., 1 second) to allow the snackbar to display
        await new Promise((resolve) => setTimeout(resolve, 1500));
        // Redirect to Home
        this.$router.push("/rules");
      } catch (error) {
        this.setError(error, false);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
